// src/redux/slices/loanSchemeSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Load base URL from environment
const BASE_URL = process.env.REACT_APP_API_URL ;

// GET - Fetch all loan schemes with superAdminId filter
export const fetchLoanSchemes = createAsyncThunk(
  "loanScheme/fetchLoanSchemes",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken"); // if you use JWT
      const superAdminId = localStorage.getItem("adminuserId"); // stored when login

      if (!superAdminId) {
        throw new Error("superAdminId not found in localStorage");
      }

      const response = await axios.get(
        `${BASE_URL}/get-loan?superAdminId=${superAdminId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ secure with JWT
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);





export const fetchServiceTypes = createAsyncThunk(
  "serviceType/fetchServiceTypes",
  async (superadminid, { rejectWithValue }) => {
    try {
      console.log("🔍 fetchServiceTypes called with superadminid:", superadminid);

      const response = await axios.get(`${BASE_URL}/all-servicetype`, {
        params: { superadminid }, // 👈 backend must expect this key
      });

      console.log("✅ API response:", response.data);

      return response.data.data;
    } catch (error) {
      console.error("❌ API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const updateService = createAsyncThunk(
  "service/updateService",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${BASE_URL}/update-service-new/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



// POST - Create a new service type
export const createServiceType = createAsyncThunk(
  "serviceType/createServiceType",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/create-servicetype`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// POST - Create a new loan scheme
export const createLoanScheme = createAsyncThunk(
  "loanScheme/createLoanScheme",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/create-loan`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// // PUT - Update existing loan scheme
// export const updateLoanScheme = createAsyncThunk(
//   "loanScheme/updateLoanScheme",
//   async ({ id, data }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(`${BASE_URL}/update/${id}`, data);
//       console.log("response update",response)
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );


// PUT - Update existing loan scheme
export const updateLoanScheme = createAsyncThunk(
  "loanScheme/updateLoanScheme",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // const response = await axios.put(`${BASE_URL}/update/${id}`, data);
      const response = await axios.put(`${BASE_URL}/loanschema/update/${id}`, data);
      console.log("Update Loan Scheme Response:", response.data);
      return response.data;

    } catch (error) {
      console.error("Update Error:", error);

      // Convert error object → readable string
      const errorMessage =
        error.response?.data?.message ||              // backend message
        (typeof error.response?.data === "string"
          ? error.response.data                       // backend string response
          : JSON.stringify(error.response?.data)) ||  // backend object → convert to string
        error.message ||                              // axios message
        "Something went wrong";                        // fallback

      return rejectWithValue(errorMessage);
    }
  }
);






export const createService = createAsyncThunk(
  "service/createService",
  async ({ name, description, superadminId, branchId, serviceTypeId }, { rejectWithValue }) => {
    try {
      // ✅ Validate required fields before API call
      if (!name || !description || !superadminId || !branchId || !serviceTypeId) {
        return rejectWithValue(
          "All fields (name, description, superadminId, branchId, serviceTypeId) are required"
        );
      }

      // ✅ API Call
      const response = await axios.post(
        `${BASE_URL}/create-service-new`,
        { name, description, superadminId, branchId, serviceTypeId }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// DELETE - Delete a loan scheme
export const deleteLoanScheme = createAsyncThunk(
  "loanScheme/deleteLoanScheme",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${BASE_URL}/delete/${id}`);
      return { id };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// const loanSchemeSlice = createSlice({
//   name: "loanScheme",
//   initialState: {
//     list: [],
//     loading: false,
//     error: null,
//     success: false,
//   },
//   reducers: {
//     resetLoanState: (state) => {
//       state.loading = false;
//       state.error = null;
//       state.success = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch
//       .addCase(fetchLoanSchemes.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLoanSchemes.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload || [];
//       })
//       .addCase(fetchLoanSchemes.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Create
//       .addCase(createLoanScheme.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(createLoanScheme.fulfilled, (state, action) => {
//         state.loading = false;
//         state.success = true;
//         state.list.push(action.payload);
//       })
//       .addCase(createLoanScheme.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Update
//       .addCase(updateLoanScheme.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(updateLoanScheme.fulfilled, (state, action) => {
//         state.loading = false;
//         state.success = true;
//         const updated = action.payload;
//         const index = state.list.findIndex((item) => item.id === updated.id);
//         if (index !== -1) {
//           state.list[index] = updated;
//         }
//       })
//       .addCase(updateLoanScheme.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Delete
//       .addCase(deleteLoanScheme.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteLoanScheme.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = state.list.filter((item) => item.id !== action.payload.id);
//       })
//       .addCase(deleteLoanScheme.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

const loanSchemeSlice = createSlice({
  name: "loanScheme",
  initialState: {
    list: [],
    serviceTypes: [], // added serviceTypes
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetLoanState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Loan Schemes
      .addCase(fetchLoanSchemes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoanSchemes.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchLoanSchemes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Loan Scheme
      .addCase(createLoanScheme.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createLoanScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.list.push(action.payload);
      })
      .addCase(createLoanScheme.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Loan Scheme
      .addCase(updateLoanScheme.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateLoanScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        const updated = action.payload;
        const index = state.list.findIndex((item) => item.id === updated.id);
        if (index !== -1) state.list[index] = updated;
      })
      .addCase(updateLoanScheme.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Loan Scheme
      .addCase(deleteLoanScheme.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLoanScheme.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter((item) => item.id !== action.payload.id);
      })
      .addCase(deleteLoanScheme.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Service Types
      .addCase(fetchServiceTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceTypes = action.payload || [];
      })
      .addCase(fetchServiceTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(updateService.pending, (state) => {
  state.loading = true;
  state.error = null;
  state.success = false;
})
.addCase(updateService.fulfilled, (state, action) => {
  state.loading = false;
  state.success = true;

  // Optionally update serviceTypes in state if needed
  const updatedService = action.payload;
  const index = state.serviceTypes.findIndex((stype) => stype.id === updatedService.id);
  if (index !== -1) {
    state.serviceTypes[index] = updatedService;
  }
})
.addCase(updateService.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
});

  },
});


export const { resetLoanState } = loanSchemeSlice.actions;
export default loanSchemeSlice.reducer;
